/* eslint-disable import/order */
import React from 'react';
import type CreateProjectType from '@jira/spa-apps__create-project/src/CreateProjectSpa.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { createProjectRoute } from '@jira/router-routes__create-project-routes/src/createProjectRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyCreateProject = lazyForPaint<typeof CreateProjectType>(
	() =>
		import(
			/* webpackChunkName: "async-create-project", jiraSpaEntry: "async-create-project" */ '@jira/spa-apps__create-project/src/CreateProjectSpa.tsx'
		),
);

const CreateProject = () => (
	<LazyPage Page={LazyCreateProject} pageId="spa-apps/create-project" shouldShowSpinner />
);

export const createProjectRouteEntry: Route = createEntry(createProjectRoute, () => ({
	group: 'components',
	// eslint-disable-next-line no-restricted-syntax
	component: CreateProject,
	layout: genericProjectLayout,

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	forPaint: [LazyAtlassianNavigation, LazyCreateProject],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
